// Shared UI helpers for MessageArea — kept separate to stay under 300 lines.

export function ThinkingDots() {
  return (
    <div className="flex items-center gap-1">
      <div className="bg-chariot-text-secondary h-2 w-2 animate-bounce rounded-full" />
      <div
        className="bg-chariot-text-secondary h-2 w-2 animate-bounce rounded-full"
        style={{ animationDelay: '150ms' }}
      />
      <div
        className="bg-chariot-text-secondary h-2 w-2 animate-bounce rounded-full"
        style={{ animationDelay: '300ms' }}
      />
    </div>
  );
}

export function AgentIcon() {
  return (
    <div className="bg-chariot-brand-primary/10 -ml-1.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full">
      <div className="bg-chariot-brand-primary h-2 w-2 rounded-full" />
    </div>
  );
}
